<template>
  <v-container fluid tag="section">
    <base-material-table
      outlined
      :item="item"
      ref="table"
      single-expand
    >
    <template v-slot:foot="{ total }">
        <td  :colspan="item.headers.length" :style="$isMobile ? '' : 'border-top: #e4e4e4 1px solid'">
          <div class="my-3 mx-4">
            金额合计：<span :class="`${$isMobile ? 'size-20': 'size-27'} blue--text font-family-Impact`">{{total === null ? 0 : total.allPrice}}</span>&nbsp;
          </div>
        </td>
      </template>
    <template v-slot:condition>
      <v-col cols="12" md='2' class="pr-2 pb-n1 pt-c-10 px-0">
        <base-marerial-user-select  @on-change="loadData" label='申请人员' hide-details outlined dense v-model="item.params.uids" :menu='$constants.SysMenu.MEDIATOR_M_ID'></base-marerial-user-select>
      </v-col>
      <v-col cols="12" md='2' class="pr-2 pb-n1 pt-c-10 px-0">
        <v-select-search
            hide-details
            outlined dense
            label="年份选择"
            :data='yearItems'
            @on-change="loadData"
            item-text="label"
            item-value="value"
            clearable
            multiple
            clear-icon="mdi-close-circle-outline"
            v-model='item.params.years'>
          </v-select-search>
      </v-col>
      <v-col cols="12" md='2' class="pr-2 pb-n1 pt-c-10 px-0">
        <v-select-search
            hide-details
            outlined dense
            label="月份选择"
            :data="monthItems"
            @on-change="loadData"
            item-text="label"
            item-value="value"
            clearable
            multiple
            clear-icon="mdi-close-circle-outline"
            v-model='item.params.months'>
          </v-select-search>
      </v-col>
    </template>
    <template v-slot:expanded-content="{ headers, item, refresh }">
      <td :colspan="headers.length" v-if='refresh' class="px-0">
        <v-divider v-if="$isMobile"></v-divider>
        <v-tabs v-model="tab">
          <v-tab>合同详情</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <contract-view mini :item='item.contract' lazy></contract-view>
          </v-tab-item>
        </v-tabs-items>
      </td>
    </template>
    </base-material-table>
    <v-dialog max-width="450" v-model="backModal">
       <template v-slot:default="dialog">
         <v-card class="pb-5">
           <v-card-title class="text-h6">
             居间费追回提示
           </v-card-title>
           <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field label="退回金额" hide-details="auto" outlined :rules="number" v-model="form.backMoney"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <base-material-date
                  ref='date'
                  :rules="required"
                  hide-details='auto'
                  outlined
                  label='退回时间'
                  v-model='form.backTimeStr'
                >
                </base-material-date>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-select
                  :items="bankAccountItems"
                  label="接收账户"
                  v-model="form.backAccountId"
                  hide-details='auto'
                  outlined
                  item-text='name'
                  item-value="id"
                  :rules="required"
                ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea rows='3' label="备注信息" hide-details="auto" outlined v-model="form.remark"></v-textarea>
                </v-col>
              </v-row>
            </v-form>
           </v-card-text>
           <v-card-actions>
             <v-spacer></v-spacer>
             <v-btn class="text--disabled" text @click="dialog.value = false">
               取消
             </v-btn>
             <v-btn color="primary" :loading="loading" @click="back">
               提交
             </v-btn>
           </v-card-actions>
         </v-card>
       </template>
    </v-dialog>
  </v-container>
</template>

<script>
  import { fmAuditColor } from '@/utils/stringUtil.js'
  import { selectData, selectMonthData } from '@/utils/tool.js'
  import { getByPids } from '@/api/system/dictionary.js'
  import ContractView from '@/views/pages/pc/contract/info/components/Detail.vue'
  import VSelectSearch from '@/components/select/v-select-search.vue'
  import { back } from '@/api/contract/mediator.js'

  export default {
    name: 'ContractMediator',
    components: {
      ContractView,
      VSelectSearch
    },
    data() {
      return {
        tab: '',
        bankAccountItems: [],
        monthItems: selectMonthData(),
        yearItems: selectData(3),
        backModal: false,
        form: {
          id: '',
          reamrk: '',
          money: '',
          backMoney: '',
          backTime: '',
          backTimeStr: '',
          backAccountId: ''
        },
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => !!value || '此项为必填项!',
          value => /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(value) || '必须输入数字',
        ],
        loading: false,
        item: {
          total: true,
          mobile: true,
          path: 'mediator/apply/list',
          topButtons: [
            { event: 'search', show: true }
          ],
          sort: {
            orderByField: 'create_time',
            asc: false
          },
          params: {
            uids: [],
            years: [],
            months: []
          },
          headers: [
             {
              text: '详情',
              align: 'center',
              divider: true,
              width: 60,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              value: '',
              sortable: false,
              mobile: true,
              icon: {
                value: 'mdi-dots-horizontal',
                onClick: (row, idx) => {
                  this.$refs.table.showMore(row, idx)
                }
              }
            },
            {
              text: '客户名称',
              align: 'center',
              divider: true,
              width: 200,
              mobile: true,
              value: 'customer.name',
              sortable: false,
              copy: true,
              search: { type: 'input', mobile: true }
            },
            {
              text: '合同编号',
              align: 'center',
              divider: true,
              width: 200,
              mobile: true,
              value: 'contract.serialNumber',
              sortable: false,
              copy: true,
              search: { type: 'input' }
            },
            {
              text: '审核状态',
              align: 'center',
              divider: true,
              width: 120,
              value: 'order',
              sortable: false,
              mobile: true,
              chip: {
                color: (val) => fmAuditColor(val.auditStatus),
                formatter: (val) => val.auditStatusVal
              },
              search: {
                mobile: true,
                type: 'select',
                secKey: 'auditStatus',
                multiple: true,
                model: [0, 1],
                options: () => [
                  { label: '审核中', value: 0 },
                  { label: '已通过', value: 1 },
                  { label: '未通过', value: -1 }
                ]
              }
            },
            {
              text: '申请类型',
              align: 'center',
              divider: true,
              width: 120,
              value: 'status',
              sortable: false,
              mobile: true,
              formatter: (val, row) => val === 1 ? '支付' : `退还(${row.backMoney})`
            },
            {
              text: '申请金额',
              align: 'center',
              divider: true,
              value: 'money',
              width: 120,
              sortable: false
            },
            {
              text: '申请人员',
              align: 'center',
              divider: true,
              value: 'createUser.name',
              width: 120,
              sortable: false
            },
            {
              text: '备注内容',
              align: 'center',
              divider: true,
              width: 200,
              value: 'remark',
              mobile: true,
              sortable: false
            },
            {
              text: '创建时间',
              align: 'center',
              value: 'createTime',
              width: 120,
              sortable: false,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
                text: '操作',
                value: 'actions',
                align: 'center',
                sortable: false,
                class: 'fixed-right',
                cellClass: 'fixed-right',
                width: 90,
                mobile: true,
                actions: [
                {
                  text: '追回',
                  color: 'warning',
                  icon: 'mdi-pencil',
                  onClick: (row) => {
                    this.backModal = true
                    this.form = { id: row.id, money: row.money, remark: row.remark, backMoney: row.money }
                  },
                  disable: (row) => (this.$store.state.userInfo.id !== row.createUserId && this.$store.state.userInfo.roleIds.indexOf(1) === -1) || row.money <= 0 || row.order.auditStatus === 0
                }
              ]
            }
          ]
        }
      }
    },
    methods: {
      back () {
        if (this.form.money >= this.form.backMoney) {
          if (this.$refs.form.validate()) {
            this.form.backTime = new Date(this.form.backTimeStr).getTime() / 1000
            this.loading = true
            back(this.form).then(res => {
              if (res.status === 200) {
                this.backModal = false
                this.loadData()
                this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
              }
              this.loading = false
            })
          }
        } else {
          this.$dialog.notify.warning(`申请金额不得大于${this.form.money}`, { position: 'top-right', timeout: 4000 })
        }
      },
      loadData () {
        this.$refs.table.loadData()
      },
      getTypes () {
        getByPids(
          {
            pids: [
              this.$constants.bankAccountPid
            ]
          }
        ).then(res => {
          if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
              if (this_.$constants.bankAccountPid === result.id) {
               this_.bankAccountItems = result.data
              }
           })
          }
        })
      },
    },
    created () {
      this.getTypes()
    }
  }
</script>

<style>
</style>
